export default IconBible => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-bible" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M19 4v16h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12z" />
  <path d="M19 16h-12a2 2 0 0 0 -2 2" />
  <path d="M12 7v6" />
  <path d="M10 9h4" />
</svg>`;